var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack427({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.86,11.78a5,5,0,0,0,1.27.67l-.58,1.12a3.92,3.92,0,0,1-.71-.29l-1.05-.7a4.36,4.36,0,0,1-1.72.34,3.75,3.75,0,0,1-2.84-1.07,4.14,4.14,0,0,1-1-3,4.12,4.12,0,0,1,1-3A3.69,3.69,0,0,1,8,4.77a3.66,3.66,0,0,1,2.78,1.08,4.16,4.16,0,0,1,1,3,5.18,5.18,0,0,1-.28,1.79A3.91,3.91,0,0,1,10.86,11.78Zm-1.28-.89A2.27,2.27,0,0,0,10,10a4.15,4.15,0,0,0,.15-1.17,3,3,0,0,0-.6-2A2,2,0,0,0,8,6.13a2,2,0,0,0-1.58.68,3,3,0,0,0-.6,2,3.05,3.05,0,0,0,.6,2.06A1.94,1.94,0,0,0,8,11.6a1.75,1.75,0,0,0,.65-.12,4.72,4.72,0,0,0-1-.49l.44-.91A5.22,5.22,0,0,1,9.58,10.89Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack427);
export default __webpack_public_path__ + "static/media/Symbolpack_4_27.12fccc58df90c5ba86a26a61de88bf14.svg";
export { ForwardRef as ReactComponent };